var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TitleAndDataLine',{attrs:{"label":_vm.label,"value":_vm.userNames}})}
var staticRenderFns = []

export { render, staticRenderFns }